<div class="container-fluid test">
  <div class="row d-flex flex-sm-row  flex-column-reverse ">
    <div class="col-md-6 bgS1 p-5 position-relative d-sm-block d-none aos-init aos-animate" data-aos="fade-up">
      <div class="row">
        <div class="col-md-8 colmd8W m-auto">
          <div class="row mb-5 d-none d-sm-block">
            <div class="col">
              <a data-testid="auto-expiry-link-a-1" class="navbar-brand z2" href="https://webbtree.com/"><img src="assets/webtree.png" class="img-fluid"
                  alt="Webbtree" title="Webbtree"></a>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <h1 class="f-32 font-weight-bold mb-3">
                Source.Enrich.Nurture
              </h1>

            </div>
          </div>
          <div class="row mb-4">
            <div class="col text-center">
              <img src="assets/group-7@2x.png" class="img-fluid" alt="Search toolbox"
                title="Search toolbox">

            </div>
          </div>
          <div class="position-absolute tr0 ">
            <img src="assets/g2c3.png" alt="">
          </div>
          <div class="row">
            <div class="col text-center">
              <p>Stay tuned for updates</p>
              <p> <span class="social-icon">
                  <a data-testid="auto-expiry-link-a-2" class="" href="https://www.linkedin.com/company/webbtree/" target="_blank"><i
                      class="fab fa-linkedin f-26 linkedinColor mr-4"></i></a>
                  <a data-testid="auto-expiry-link-a-3" class="" href="mailto:support@webbtree.com" target="_blank"><i
                      class="fas fa-envelope f-26 emailColor mr-4"></i></a>
                  <a data-testid="auto-expiry-link-a-4" class="" href="https://www.facebook.com/webbtreeapp/" target="_blank"> <i
                      class="fab fa-facebook-square f-26 facebookColor mr-4"></i></a>

                  <a data-testid="auto-expiry-link-a-5" class="" href="https://twitter.com/Webbtreeapp/" target="_blank"><i
                      class="fa-brands fa-square-x-twitter f-26 twitterColor"></i></a>
                </span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 p-5 testmobile aos-init aos-animate bg-white-h100" data-aos="fade-up">

      <div class="row">
        <div class="col-md-12">

          <div class="row mb-3">
            <div class="col text-right">
              <span>
                Don't have webtree Account? &nbsp; &nbsp; <button data-testid="auto-expiry-link-button-1" class="wc-btn btnreset col-md-2 m-auto py-1"
                  routerLink="/signup">Sign Up</button>
              </span>
              <p> <img class="mt-4" src="assets/g2c4.png" alt=""></p>
            </div>
          </div>


          <div *ngIf="true" class="col-10">
            <div class="row">
              <div class="col-md-12 wccard text-center expiry">
                <div class="row">
                  <div class="col d-flex align-items center justify-content-center 100vh img-height">
                    <div class="img ">
                      <img src="../assets/images/expiry.png" class="img-fluid mb-3" alt="" srcset="">
                      <div>
                        <p class="font-weight-bold f-18">Password reset link is expired</p>
                        <p class="f-18 gray-text">Please enter your email address below to resend the password reset link</p>
                      </div>

                    </div>
                  </div>
                </div>
            </div>
          </div>
            <div class="row">
              <div class="col pr-sm-0">
                <form [formGroup]="pwd_reset_link_form">
                    <div class="mr-4 mb-3">
                      <div class="f-12 font-weight-500 mb-3"> Email address
                        <input data-testid="auto-expiry-link-input-1" type="text" placeholder="Enter Email Id" class="wc-form-control nobg mt-1" formControlName = 'emailid'>
                      </div>
                      <p *ngIf="pwd_reset_link_form.get('emailid').errors?.required && (pwd_reset_link_form['controls'].emailid.dirty || pwd_reset_link_form['controls'].emailid.touched)"
                        [ngClass]="['text-left','my-1','text-danger' ,'f-12']">Email ID is required</p>
                      <p class="text-danger f-12 pt-1" *ngIf="pwd_reset_link_form['controls'].emailid.hasError('pattern')">
                        Must be a valid EmailId</p>
                      <div class="mt-5">
                        <button data-testid="auto-expiry-link-button-2" type="button" class="btn-trms-medium mr-4"
                          data-dismiss="modal" (click)="requestlink()">Request Reset Link</button>
                      </div>
                    </div>
                </form>
                <div class="text-right pr-3 w-65 d-none d-sm-block">
                  <img src="" class="img-fluid" alt="">
                </div>
              </div>
            </div>
          </div>

    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
